import { render, staticRenderFns } from "./DrawcordMaterialEdit.vue?vue&type=template&id=47d1abb0&"
import script from "./DrawcordMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./DrawcordMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports